import {forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState} from "react";
import TerminalContainerContext from "./TerminalContainerContext.ts";
import { useTranslation } from "react-i18next";
import HelpDialog from "../HelpDialog.tsx";


export type TerminalContainerTitleBarRef = HTMLDivElement;

const TerminalContainerTitleBar = forwardRef<TerminalContainerTitleBarRef>(
    (_, ref) => {
        const { t } = useTranslation("ui");
        const divRef = useRef<HTMLDivElement>(null);
        const dropdownRef = useRef<HTMLDivElement>(null);
        const context = useContext(TerminalContainerContext)!;
        const [modalOpen, setModalOpen] = useState(false);

        const title = context.activeTab?.title;

        function onClickActionAnchor(event: Event) {
            event.preventDefault();
            const target = event.currentTarget! as HTMLElement;
            const action = target.dataset["action"]!;
            context.executeInstanceAction(action);
        }

        useImperativeHandle(ref, () => divRef.current!);

        useEffect(() => {
            const actionItems = dropdownRef.current!.querySelectorAll(".dropdown-item");
            actionItems.forEach(item => {
                item.addEventListener('click', onClickActionAnchor);
            });

            return () => {
                actionItems.forEach(item => {
                    item.removeEventListener('click', onClickActionAnchor);
                })
            };
        })

        return (
            <div>
                <HelpDialog open={modalOpen} onClose={() => setModalOpen(false)}/>
                <div className={"container-title-bar"} ref={divRef}>
                    <div className="text-end col-md-5 px-5 mt-1"
                         style={{position: "absolute", left: "60%", top: "1%"}}>
                        <div className="row w-75" style={{float: "right"}}>
                            <p className="text-secondary col-md-6 pt-3 px-0">
                                {t("terminal.shortcutHelp", { hotkey: "Alt + H" })}
                            </p>
                            <div className="pt-2 col-md-3 px-0">
                                <button className="button_blue-sm p-2 rounded-3"
                                        type="button"
                                        onClick={() => setModalOpen(true)}
                                        aria-expanded="false">
                                    {t("terminal.help")}
                                </button>
                            </div>
                            <div className="dropdown pt-2 col-md-2">
                                <button className="button_blue-sm p-2 rounded-3 dropdown-toggle"
                                        type="button"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                    {t("common.action")}&nbsp;
                                </button>
                                <div ref={dropdownRef} className="dropdown-menu dropdown-menu-end">
                                    <a className="dropdown-item" data-action="close">{t("terminal.actions.close")}</a>
                                    <a className="dropdown-item" data-action="shutdown">{t("instance.actions.shutdown")}</a>
                                    <a className="dropdown-item" data-action="hard-restart">{t("instance.actions.restart")}</a>
                                    <a className="dropdown-item" data-action="resume">{t("instance.actions.resume")}</a>
                                    <a className="dropdown-item" data-action="pause">{t("instance.actions.pause")}</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h4 className="text-center text-primary d-block">{title ?? t("terminal.status.connectingShort")}</h4>
                    <hr/>
                </div>
            </div>

        )
    }
)

export default TerminalContainerTitleBar;